import * as React from 'react';

import { Amenity } from '.';
import { UitkHeading } from 'uitk-react-text';
import { IconAndLabelType } from 'src/types/shared';

interface AmenityListProps {
  amenities: IconAndLabelType[];
  heading?: string;
}

export const AmenitiesList = ({ amenities, heading }: AmenityListProps) => {
  return (
    <>
      {heading && (
        <UitkHeading level={4} size={300}>
          {heading}
        </UitkHeading>
      )}
      <ul className="uitk-type-list-300 icon-s all-t-padding-three" data-test-id="amenities-list" role="list">
        {amenities.map((amenity, ruleIndex) => (
          <Amenity key={ruleIndex} amenity={amenity} />
        ))}
      </ul>
    </>
  );
};
